import React from 'react'
import { type Column } from './utils'

interface UsersTableSkeletonProps {
  visibleColumns: Column[]
  rowCount?: number
}

export const UsersTableSkeleton: React.FC<UsersTableSkeletonProps> = ({
  visibleColumns,
  rowCount = 8,
}) => {
  return (
    <>
      {Array.from({ length: rowCount }).map((_, rowIndex) => (
        <tr key={rowIndex} className="animate-pulse">
          {visibleColumns.map((column) => (
            <td key={column.key} className="px-6 py-4 whitespace-nowrap">
              <div className="flex items-center">
                {column.key === 'email' ? (
                  <div className="flex items-center">
                    <div className="h-10 w-10 rounded-full bg-secondary/20 me-4"></div>
                    <div>
                      <div className="h-4 bg-secondary/20 rounded w-32 mb-2"></div>
                      <div className="h-3 bg-secondary/20 rounded w-48"></div>
                    </div>
                  </div>
                ) : column.key === 'role' ? (
                  <div className="h-6 bg-secondary/20 rounded-full w-20"></div>
                ) : column.key === 'accessGroups' ? (
                  <div className="h-4 bg-secondary/20 rounded w-16"></div>
                ) : column.key === 'createdAt' || column.key === 'lastLoginAt' ? (
                  <div className="h-4 bg-secondary/20 rounded w-24"></div>
                ) : (
                  <div className="h-4 bg-secondary/20 rounded w-20"></div>
                )}
              </div>
            </td>
          ))}
        </tr>
      ))}
    </>
  )
}
